export default class ClubReverseInvoice {
    static fromData(data) {
        if (!data) {
            return;
        }

        const clubReverseInvoice = new ClubReverseInvoice();
        clubReverseInvoice.active = false;
        clubReverseInvoice.id = data.id;
        clubReverseInvoice.isReverseInvoice = true;
        clubReverseInvoice.number = data.number;
        clubReverseInvoice.createdAt = data.createdAt;
        clubReverseInvoice.invoiceRecipient = data.invoiceRecipient;
        clubReverseInvoice.paymentMethod = data.paymentMethod;
        clubReverseInvoice.gross = data.gross;
        clubReverseInvoice.currency = data.currency;
        clubReverseInvoice.canceled = false;
        clubReverseInvoice.canceledInvoiceId = data.canceledInvoiceId;
        clubReverseInvoice.pdfExists = data.pdfExists;
        clubReverseInvoice.pdfLastDownload = data.pdfLastDownload;
        clubReverseInvoice.pdfLastDownloadByMember = data.pdfLastDownloadByMember;
        clubReverseInvoice.pdfLastSendAsEmail = data.pdfLastSendAsEmail;
        clubReverseInvoice.pdfLastSendAsEmailFinished = data.pdfLastSendAsEmailFinished;
        clubReverseInvoice.xInvoiceExists = data.xInvoiceExists;
        clubReverseInvoice.deletable = data.deletable;
        clubReverseInvoice.notDeletableReasons = data.notDeletableReasons;

        Object.seal(clubReverseInvoice);
        return clubReverseInvoice;
    }
}
